import { Injectable } from '@angular/core';
import { OrderHistoryAdapter, OrderHistoryConnector } from '@spartacus/order/core';
import { Order, OrderHistoryList } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { OrdersFilter } from '../../../../model/order-filters.model';
import { CustomUserOrderAdapter } from './custom-user-order.adapter';

@Injectable({
  providedIn: 'root',
})
export class CustomUserOrderConnector extends OrderHistoryConnector {
  constructor(
    protected adapter: OrderHistoryAdapter,
    protected customUserOrderAdapter: CustomUserOrderAdapter
  ) {
    super(adapter);
  }

  public getHistoryFilter(
    userId: string,
    pageSize?: number,
    currentPage?: number,
    sort?: string,
    ordersFilter?: OrdersFilter,
  ): Observable<OrderHistoryList> {
    return this.customUserOrderAdapter.loadHistoryFilter(userId, pageSize, currentPage, sort, ordersFilter);
  }

  public getOrderStatusList(): Observable<any> {
    return this.customUserOrderAdapter.loadOrderStatusList();
  }

  public geOrderDetail(userId: string, orderCode: string): Observable<Order> {
    return this.customUserOrderAdapter.loadOrderDetail(userId, orderCode);
  }
}
